// ===================================================================
// KAIXO - Badge de verificación
// ===================================================================
// Muestra una insignia según el nivel de verificación del usuario:
//   basic    → verde (identidad)
//   creator  → morado (creador)
//   business → azul (negocio)
// ===================================================================

import React from 'react';
import './VerifiedBadge.css';

const CONFIG = {
    basic:    { color: '#22c55e', title: 'Identidad verificada' },
    creator:  { color: '#8b5cf6', title: 'Creador verificado' },
    business: { color: '#3b82f6', title: 'Negocio verificado' }
};

export default function VerifiedBadge({ level, size = 16, inline = true }) {
    const cfg = CONFIG[level];
    if (!cfg) return null;
    return (
        <span
            className={`vb-badge ${inline ? 'vb-inline' : ''}`}
            title={cfg.title}
            aria-label={cfg.title}
        >
            <svg viewBox="0 0 24 24" width={size} height={size}>
                <circle cx="12" cy="12" r="10" fill={cfg.color} />
                <path
                    d="M8 12.3l2.8 2.8L16.5 9.4"
                    stroke="white"
                    strokeWidth="2.4"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    );
}
